import script from "./OrganizeActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizeActivity.vue?vue&type=script&setup=true&lang=js"

import "./OrganizeActivity.vue?vue&type=style&index=0&id=70e1eadc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e1eadc"]])

export default __exports__